import { GET_SECTION, GET_SECTION_ID, POST_SECTION, UPDATE_SECTION, DELETE_SECTION } from "../type";

const initialState = {
    listSection: [],
    section: {},
};

const section = (state = initialState, action) => {
    switch (action.type) {
        case GET_SECTION:
            return {
                ...state,
                listSection: action.data,
            };
        case GET_SECTION_ID:
            return {
                ...state,
                section: action.data,
            };
        case POST_SECTION:
            return {
                ...state,
                listSection: [...state.listSection, action.data],
            };
        case UPDATE_SECTION:
            return {
                ...state,
                listSection: state.listSection.map((item) => (item._id === action.data._id ? action.data : item)),
                section: action.data,
            };
        case DELETE_SECTION:
            return {
                ...state,
                listSection: state.listSection.filter((item) => item._id !== action.data._id),
            };
        default:
            return state;
    }
};

export default section;
